import React from "react";
import Carousel from "../carousel/Carousel";
import { SwiperSlide } from "swiper/react";

interface slideContant {
  description: string;
  img: string;
}

const silderContact: slideContant[] = [
  {
    description:
      "Customers are required to enter valid mobile number. An OTP will be sent to registered mobile number to lodge your complaint/feedback.",
    img: "/imgaes/OTP.png",
  },
  {
    description:
      "Non-Customers are also required to provide valid mobile number. Verification OTP will be sent on mobile number.",
    img: "/imgaes/Mobie-Grr.png",
  },
  {
    description:
      "If your mobile number is not registered with the account, please get your mobile number registered at your branch to avail this facility.",
    img: "/imgaes/userfriendly.png",
  },
];

const LoginContantData = ({ className }: any) => {
  return (
    <div>
      <div>
        <h3 className="text-lg text-center mb-0">Welcome</h3>
        <p className="text-sm text-center mb-0">Online Complaint/Grievances System</p>
        <Carousel
          pagination={false}
          navigation={false}
          className="main-caro"
          autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
          style={{ height: "100%", width: 350 }}
        >
          {silderContact.map((item, i) => (
            <SwiperSlide key={i}>
              <div className={`d-flex justify-content-center my-3 ${className}`}>
                <img src={item.img} alt="Imges" style={{ width: "55%" }} />
              </div>
              <div className="card-title px-3 mt-3">
                {/* <h5 className="mb-2 text-center ">{item.title}</h5> */}
                <p className="text-center text-xs login-content text-slate-500">{item.description}</p>
              </div>
            </SwiperSlide>
          ))}
        </Carousel>
      </div>

    </div>
  );
};

export default LoginContantData;
